import React, { useState } from "react";
import { Table, Input, Space } from "antd";

const VehicleActivityRatesTable = ({ dashboardData }) => {
  const vehicleActivityRates = dashboardData.vehicleActivityRates || [];
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState(vehicleActivityRates);
  const [pageSize, setPageSize] = useState(5); // Giá trị mặc định cho pageSize

  // Hàm xử lý tìm kiếm
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);

    const filtered = vehicleActivityRates.filter((item) =>
      item.bien_kiem_soat.toLowerCase().includes(value) ||
      item.loai_xe.toLowerCase().includes(value)
    );

    setFilteredData(filtered);
  };

  // Định nghĩa các cột cho bảng
  const columns = [
    {
      title: "STT",
      dataIndex: "stt",
      key: "stt",
      render: (text, record, index) => index + 1,
      align: "center",
    },
    {
      title: "Biển kiểm soát",
      dataIndex: "bien_kiem_soat",
      key: "bien_kiem_soat",
      align: "center",
    },
    {
      title: "Loại xe",
      dataIndex: "loai_xe",
      key: "loai_xe",
      align: "center",
    },
    {
      title: "Trọng tải (Kg)",
      dataIndex: "trong_tai",
      key: "trong_tai",
      render: (text) => text.toLocaleString(),
      align: "center",
    },
    {
      title: "Chi phí thuê xe (₫)",
      dataIndex: "cp_thue_xe",
      key: "cp_thue_xe",
      render: (text) => Number(text).toLocaleString("vi-VN"),
      align: "center",
    },
    {
      title: "Tỷ lệ hoạt động (%)",
      dataIndex: "ty_le_hoat_dong",
      key: "ty_le_hoat_dong",
      align: "center",
    },
    {
      title: "Thời gian thuê",
      dataIndex: "thoi_gian_thue",
      key: "thoi_gian_thue",
      render: (text) => new Date(text).toLocaleDateString("vi-VN"),
      align: "center",
    },
  ];

  return (
    <div style={{ margin: "20px" }}>
      <h5 className="text-primary fw-bold mb-3 text-center">
        Chi tiết tỷ lệ hoạt động của từng xe
      </h5>
      <Space style={{ marginBottom: 16 }}>
        <Input
          placeholder="Tìm kiếm biển kiểm soát hoặc loại xe"
          value={searchText}
          onChange={handleSearch}
          allowClear
          style={{ width: 300 }}
        />
      </Space>
      <div id='vehicle-activity-rates' style={{ overflowX: "auto" }}>
        <Table
          dataSource={filteredData}
          columns={columns}
          rowKey="bien_kiem_soat"
          pagination={{
            pageSize, // Giá trị mặc định cho pageSize
            showSizeChanger: true, // Cho phép người dùng thay đổi pageSize
            pageSizeOptions: ["5", "10", "20", "50"], // Các tùy chọn số lượng phần tử
            onShowSizeChange: (current, size) => setPageSize(size), // Cập nhật pageSize khi thay đổi
          }}
          scroll={{ x: 1000 }} // Bảng sẽ cuộn ngang nếu chiều rộng không đủ
          bordered
        />
      </div>
    </div>
  );
};

export default VehicleActivityRatesTable;
